import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, initialize, destroy } from 'redux-form'
import { loadScript } from 'shared/dom'
import validate from './validate'
import * as premium from 'services/premium/selectors'
import styles from './_ccForm.css'
import { Row, Col } from 'react-flexbox-grid'
import { FormattedMessage } from 'react-intl'
import NameField from './NameField'
import PostalCodeField from './PostalCodeField'
import ExpiresField from './ExpiresField'
import CVCField from './CVCField'
import CardNumberField from './CardNumberField'
import Button from 'components/util/Button'

export const FORM_NAME = 'creditCard'

const formOptions = {
  form: FORM_NAME,
  validate,
}

const mapStateToProps = (state) => ({
  stripeKey: premium.selectStripeKey(state),
})

const mapDispatchToActions = {
  initialize,
  destroy,
}

export class CCForm extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func,
    stripeKey: PropTypes.string,
    stripeURL: PropTypes.string,
    mode: PropTypes.oneOf(['create', 'edit']),
    submitting: PropTypes.bool,
    showButtons: PropTypes.bool,
    onCancel: PropTypes.func,
    defaultProfile: PropTypes.object,
    initialize: PropTypes.func,
    destroy: PropTypes.func,
  };

  static defaultProps = {
    mode: 'create',
    stripeURL: 'https://js.stripe.com/v2/',
    defaultProfile: {},
    showButtons: true,
  };

  state = {
    initialized: false,
  };

  componentDidMount () {
    const { defaultProfile, mode } = this.props

    this.loadStripe()

    if (mode === 'edit') {
      this.initializeWithProfile(defaultProfile)
    }
  }

  componentWillUnmount () {
    this.props.destroy(FORM_NAME)
  }

  initializeWithProfile (defaultProfile) {
    const cardType = defaultProfile.cc_brand
      .toLowerCase()
      .replace(' ', '-')

    this.props.initialize({
      name: defaultProfile.customer_name,
      address_zip: defaultProfile.billing_zip_code,
      exp_month: defaultProfile.cc_expiration_month,
      exp_year: defaultProfile.cc_expiration_year,
      cvc: cardType === 'american-express' ? '****' : '***',
    })
  }

  async loadStripe () {
    const { stripeURL } = this.props

    if (!window.Stripe) {
      try {
        await loadScript(stripeURL)
        Stripe.setPublishableKey(this.props.stripeKey)
        this.setState({ initialized: true })
      } catch (error) {
        this.setState({ initialized: false, error: 'initialize' })
      }
    } else {
      this.setState({ initialized: true })
    }
  }

  render () {
    const { submitting, defaultProfile, handleSubmit, mode, showButtons, onCancel } = this.props
    const { initialized, error } = this.state

    return (
      <form onSubmit={handleSubmit} className={styles.container}>

        {error ?
          <div className={styles.error}>
            <FormattedMessage
              id='premium.checkout.error_ccform'
              defaultMessage='Unable to load credit card form.'
            />
          </div>
        : null}

        <Row className={styles.row}>
          <Col xs={12} sm={6}>
            <NameField
              required
              name='name'
              disabled={!initialized}
            />
          </Col>
          <Col xs={12} sm={6}>
            <CardNumberField
              required
              name='number'
              mode={mode}
              disabled={!initialized || mode === 'edit'}
              defaultProfile={defaultProfile}
              last4={defaultProfile.cc_last4}
              brand={defaultProfile.cc_brand}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12} sm={3}>
            <PostalCodeField
              required
              name='address_zip'
              disabled={!initialized}
            />
          </Col>
          <Col xs={12} sm={4} smOffset={3}>
            <ExpiresField
              required
              name='exp'
              disabled={!initialized}
              formName={FORM_NAME}
            />
          </Col>
          <Col xs={12} sm={2}>
            <CVCField
              required
              mode={mode}
              name='cvc'
              disabled={!initialized || mode === 'edit'}
            />
          </Col>
        </Row>

        {showButtons ?
          <div className={styles.buttonList}>

            <Button
              className={styles.buttonListItem}
              onClick={onCancel}
              type='secondary'
              loading={submitting}
            >
              <FormattedMessage id='premium.checkout.ccform.cancel' defaultMessage='Cancel' />
            </Button>

            <Button
              el='button'
              type='primary'
              loading={submitting}
              className={styles.buttonListItem}
            >
              {mode === 'edit'
                ? <FormattedMessage id='premium.checkout.save_card' defaultMessage='Save card' />
                : <FormattedMessage id='premium.checkout.add_card' defaultMessage='Add card' />
              }
            </Button>

          </div>

        : null}

      </form>
    )
  }

}

export const Form = reduxForm(formOptions)(CCForm)

export default connect(mapStateToProps, mapDispatchToActions, null, { withRef: true })(Form)



// WEBPACK FOOTER //
// ./src/components/premium/CCForm/CCForm.jsx